import React from 'react';
import NewSensorTypePage from './NewSensorTypePage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import unitsActions from '../../../../../actions/units.actions';
import { bindActionCreators } from 'redux';
import helper from '../../../../../utils/helper';
import qs from 'qs';

const form = {
  typeName: '',
  alarmDelayType: false,
  alarmDelayTypeText: 'Time (sec)',
  alarmDelay: '',
  dataType: false,
  dataTypeText: 'Analog',
  decimalPrecision: '',
  units: '',
  unitsText: '',
  parameter: '',
  commLossTime: '20',
  chartMin: '',
  chartMax: '',
  includeInBatchReports: false,
  lowAlarmInOperation: '',
  lowWarningInOperation: '',
  highWarningInOperation: '',
  highAlarmInOperation: '',
  normalLogTimeInOperation: '600',
  alarmTimeInOperation: '60',
  lowAlarmAtRest: '',
  lowWarningAtRest: '',
  highWarningAtRest: '',
  highAlarmAtRest: '',
  normalLogTimeAtRest: '600',
  alarmLogTimeAtRest: '60',
  chartUnits: '', //calcUnits
  calcUnitsText: '',
  calcDecimalPrecision: '',
  calcChartMin: '',
  calcChartMax: '',
};

class NewSensorType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      units: [],
      loading: false,
      isSubmitting: false,
      errors: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.units.units !== prevState.units) {
      state.units = nextProps.units.units;
    }
    state.errors = helper.centralizeError([
      nextProps.units.errors,
      nextProps.configure.errors,
    ]);
    if (nextProps.units.loading !== prevState.loading) {
      state.loading = nextProps.units.loading;
    }
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    await this.props.unitsActions.getUnits();
    const { copiedFrom } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    if (copiedFrom) {
      await this.props.configureActions.getSpecificSensorType(copiedFrom);
    }
  }

  onCreateSensorType = (params) => {
    const { deptId } = this.props.match.params;
    this.props.configureActions
      .createSensorType({ ...params, deptId })
      .then(() => this.props.history.goBack())
      .catch((err) => console.log(err));
  };

  getChartUnits = () => {
    const { units } = this.state;
    if (units.length) {
      const result = units.filter(
        (unit) => unit.id === 1702 && unit.units === 'Std Dev',
      )[0];
      if (result) {
        return result.units;
      }
    } else return '';
  };
  render() {
    const { loading } = this.state;
    const { sensorType } = this.props.configure;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    const _sensorType = Object.assign({}, { ...sensorType, typeName: '' });
    if (Object.keys(sensorType).length) {
      _sensorType.alarmDelayTypeText = sensorType.alarmDelayType
        ? 'Updates'
        : 'Time (sec)';
      _sensorType.dataTypeText = sensorType.dataType ? 'Digital' : 'Analog';
      _sensorType.unitsText = sensorType.units;
      _sensorType.calcUnitsText = sensorType.chartUnits;
    }
    form.chartUnits = this.getChartUnits();
    const { copiedFrom } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    return (
      <NewSensorTypePage
        {...this.state}
        form={copiedFrom ? _sensorType : form}
        onCreateSensorType={this.onCreateSensorType}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    units: state.units,
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    unitsActions: bindActionCreators(Object.assign({}, unitsActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewSensorType);
